export const MU_SET_PROFILE_DATA = 'mutations/company/profile'
